<template>
    <section class="py-4 py-md-5">
        <p class="max-w-lg mx-auto px-3">
            *Proizvodi i usluge koji ne ulaze u obračun poena su sledeći
            izuzeci: sladoled, cigarete, TAG uređaji, otkupinine, sve vrste
            dopuna MTS, Yettel, A1 itd. Prikupljenim poenima ne mogu se platiti
            navedeni artikli.
        </p>
    </section>
</template>
